import { useEffect } from "react";
import "./sourceTable.css";
import EntityLinksDropdown from "./entityLinksDropdown";
import { App, Spin, Table } from "antd";
import { onSorter } from "../../../utils";
import { useTabsContext } from "../../../contexts/tabsContext";
import Filters from "../../masterComponents/Filters";
import { useFiltersContext } from "../../../contexts/filtersContext";
import { useFetchData as usePagination } from "../../../hooks/useFetch/pagination";
import { useCommonPropertiesContext } from "../../../contexts/commonPropertiesContext";
import { ContainerWrapper, SpinWrapper } from "../../../app/app.style";
import { DEFAULT_OPEN_KEYS_SOURCE_TABLE } from "../../../entities/entities";
import { LoadingOutlined } from '@ant-design/icons';
import { StyledTableItemLink } from "../analysisAgent/_ui/layouts/styles/examplesAttrAnalyserTable.style";
import { useFilterStructure } from "../../../hooks/useFilterStructure/useFilterStructure";
import { buildFilterStructure } from "../../../utils/filtersStructureHelpers";

const SourceTable = () => {
    const { message: messageApi } = App.useApp();
    const { setActiveTabKey, setId } = useTabsContext();
    const { currentBatch, setChoosedBatchToQA } = useCommonPropertiesContext();
    const {
        appliedFilters, setAppliedFilters,
        ignoredFilter, setIgnoredFilter,
        updateFilter,
    } = useFiltersContext();
    const {
        availableFilters: availableSourceTableFilters,
        activeFilters,
    } = useFilterStructure("sourceTable");

    const [fetchAllItems, {
        isLoading: isLoadingAllItemsData,
        data: allItemsData,
        page,
        totalRows,
        error: allItemsDataError,
        loadMore,
        clearError: clearAllItemsDataError,
    }] = usePagination({
        optionalArray: [currentBatch],
        query: "/@batch/items",
        selectData: (data) => data.items.map(item => ({
            key: item._id,
            ...item
        })),
        selectPageInfo: (data) => data.page_info
    })

    const filterStructure = buildFilterStructure(activeFilters);

    useEffect(() => {
        fetchAllItems({ "batch": currentBatch }, { filters: filterStructure })
    }, [])

    useEffect(() => {
        if (allItemsDataError) {
            messageApi.error(allItemsDataError.message);
            clearAllItemsDataError?.();
        }
    }, [allItemsDataError, messageApi]);

    const handleApply = () => {
        fetchAllItems({ "batch": currentBatch }, { filters: filterStructure })
    }

    const columns = [
        {
            title: "Classification",
            dataIndex: "class_name",
            key: "class",
        },
        {
            title: "Tag",
            dataIndex: "tag",
            key: "tag",
            width: 120,
        },
        {
            title: "Item",
            dataIndex: "item",
            key: "item",
            sorter: true,
            render: (item: any) => (
                <EntityLinksDropdown material={item} children={<StyledTableItemLink><a className="table-item-link">{item}</a></StyledTableItemLink>} />
            ),
        },
        {
            title: "Tag Description",
            key: "description",
            dataIndex: "description",
            sorter: true
        },
        {
            title: "Flags",
            key: "flags",
            dataIndex: "flags"
            // filters: [
            //     {
            //         text: "Annotated",
            //         value: "annotated",
            //     },
            //     {
            //         text: "Verified",
            //         value: "verified",
            //     },
            //     {
            //         text: "Partially Verified",
            //         value: "partially verified",
            //     },
            //     {
            //         text: "Unverified",
            //         value: "unverified",
            //     },
            // ],
        },
        {
            title: "Actions",
            key: "actions",
            dataIndex: "actions",
            width: 50,
            render: (_: any, record: { _id: string }) => (
                <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    {/* <a className="table-item-link" onClick={(e) => { e.preventDefault(); }}>Annotate</a> */}
                    <StyledTableItemLink>
                        <a onClick={(e) => {
                            e.preventDefault();
                            setChoosedBatchToQA(currentBatch);
                            setId(record._id);
                            setActiveTabKey("QAManager");

                        }}>QA</a>
                    </StyledTableItemLink>
                </div>
            )
        },
    ];

    return (
        <ContainerWrapper $paddingMode="top" $withoutGap="true">
            <Filters
                appliedFilters={appliedFilters}
                setAppliedFilters={setAppliedFilters}
                currentAvailableFilters={availableSourceTableFilters}
                needApplyButton={true}
                ignoredFilter={ignoredFilter}
                setIgnoredFilter={setIgnoredFilter}
                updateFilter={updateFilter}
                handleApply={handleApply}
                defaultOpenKeys={DEFAULT_OPEN_KEYS_SOURCE_TABLE}
            />
            <SpinWrapper>
                <Spin indicator={<LoadingOutlined />} spinning={isLoadingAllItemsData} />
            </SpinWrapper>
            <Table
                className="primary-table"
                rowKey="material"
                columns={columns}
                dataSource={allItemsData}
                showSorterTooltip={false}
                onChange={(pagination, filters, sorter) => {
                    if (page == pagination.current) {
                        const sort = onSorter(sorter);
                        fetchAllItems({ "batch": currentBatch }, { filters: filterStructure, sort: sort })
                    } else {
                        loadMore(pagination.current);
                    }
                }}
                pagination={
                    allItemsData?.length ? {
                        current: page,
                        pageSize: 15,
                        showSizeChanger: false,
                        total: totalRows,
                    } : null
                }
            // rowSelection={{
            //     type: "checkbox",
            //     selectedRowKeys: selectedItems,
            //     onChange: setSelectedItems,
            //     getCheckboxProps: (record) => ({
            //         disabled: props.batch == QUARANTINE_BATCH,
            //     })
            // }}
            />
        </ContainerWrapper>
    )
}
export default SourceTable;
